export default "__VITE_ASSET__826aacad__$_?nuxt_component=async__"